import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HERO_BG =
  "https://images.unsplash.com/photo-1767950470198-c9cd97f8ed87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbW9kZXJuJTIwYXJjaGl0ZWN0dXJlJTIwbmlnaHR8ZW58MHx8fHwxNzc4MTg3ODYyfDA&ixlib=rb-4.1.0&q=85";

export default function Hero({ onGetInfo }) {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen w-full flex items-end overflow-hidden grain"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 hero-vignette" />
      <div className="absolute inset-0 bg-white/40" />

      {/* numbered side rail */}
      <div className="hidden lg:flex absolute left-6 top-1/2 -translate-y-1/2 flex-col gap-6 z-10">
        {["01", "02", "03", "04"].map((n, i) => (
          <div key={n} className="flex items-center gap-3">
            <span className={`numeric text-xs ${i === 0 ? "text-[#121275]" : "text-black/30"}`}>
              {n}
            </span>
            <div className={`h-px w-8 ${i === 0 ? "bg-[#121275]" : "bg-black/20"}`} />
          </div>
        ))}
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-24 pt-40">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="overline mb-6">For Producing Agents</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl font-medium tracking-tighter leading-[0.95] text-[#0a0a0a] max-w-5xl">
            Keep more of <br />
            what <em className="not-italic text-[#121275] font-medium">you</em> earn.
            <br />
            <span className="text-black/75 font-medium">Build something inevitable.</span>
          </h1>

          <p className="mt-10 max-w-xl text-lg text-black/80 font-normal leading-relaxed">
            Sold By 1st Choice is the brokerage built for producers who refuse to subsidize
            bloated corporate overhead.{" "}
            <span className="text-[#0a0a0a]">$3,500 flat / year.</span>{" "}
            <span className="text-[#0a0a0a]">$150 per unit sold.</span>{" "}
            <span className="text-[#0a0a0a]">World-class tech.</span> That's the entire fee
            structure.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <Link to="/apply" data-testid="hero-apply-button" className="btn-primary group">
              Apply to Join
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <button onClick={onGetInfo} data-testid="hero-getinfo-button" className="btn-secondary">
              Get Info Pack
            </button>
          </div>

          <div className="mt-20 grid grid-cols-2 gap-8 max-w-md">
            {[
              { k: "$3,500", v: "Flat Annual Fee" },
              { k: "$150", v: "Per Unit Sold" },
            ].map((s) => (
              <div key={s.v} className="border-l border-[#121275] pl-4 py-1">
                <div className="numeric text-2xl sm:text-3xl text-[#0a0a0a] tracking-tight">{s.k}</div>
                <div className="text-xs uppercase tracking-widest text-black/50 mt-1 font-mono">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
